import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../redux/actions';
import Button from '../button/Button';
import Lottie from '../lottie/Lottie';
export var COUPON_MODAL = 'COUPON_MODAL';
var CouponModal = function(param) {
    var coupon = param.coupon, show = param.show, title = param.title, onAccept = param.onAccept, onAcceptLabel = param.onAcceptLabel;
    var dispatch = useDispatch();
    var onHide = function() {
        dispatch(hideModal(COUPON_MODAL));
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        className: "CouponModal",
        show: show,
        onHide: onHide,
        centered: true
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement(Lottie, {
        lottie: "free-gift"
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", null, title), /*#__PURE__*/ React.createElement("div", {
        className: "form-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onAccept
    }, onAcceptLabel)))));
};
export default CouponModal;
